import { ApiPaging } from "./paging";

export interface ModelConstructor<T> {
  new (data: any): T;
}

export class ApiResponse<T> {
  public data: T;

  public success: boolean;
  public errors: any[];
  public error?: Error;

  constructor(
    response: any,
    model: ModelConstructor<T>
  ) {
    this.data = response.data != null
      ? new model(response.data)
      : response.data;

    this.success = response.success;
    this.errors = response.errors;
    this.error = response.error;
  }
}

export class ApiListResponse<T> {
  public items: T[];
  public paging?: ApiPaging;
  public deleted?: Array<string | number>;

  public success: boolean;
  public errors?: any[];
  public error?: Error;

  public filters?: {
    key: string,
    label: string,
    default: boolean
  }[]

  public filter?: {
    attributes?: Record<string, string>,
    key?: string | null,
  } | null

  public sorts?: {
    active?: {
      name: string,
      direction: 'asc' | 'desc'
    },
    options: {
      key: string,
      label: string,
      default?: boolean
    }[]
  }

  constructor(
    response: {
      data: any
      paging?: {
        page: string,
        limit: string,
        itemCount: number,
        pageCount: number,
      }
      filters?: {
        key: string,
        label: string,
        default: boolean
      }[],
      filter?: {
        attributes?: Record<string, string>,
        key?: string | null,
      } | null,
      sorts?: {
        active?: {
          name: string,
          direction: 'asc' | 'desc'
        },
        options: {
          key: string,
          label: string,
          default?: boolean
        }[]
      },
      success: boolean
      errors?: any[]
      error?: Error,
      deleted?: Array<string | number>,
      timestamp?: number
    },
    model: ModelConstructor<T>
  ) {
    this.items = Array.isArray(response.data)
      ? response.data.map((item: any) => new model(item))
      : [];

    if (response.paging) {
      this.paging = new ApiPaging(response.paging);
    }
    this.filters = response.filters;
    this.filter = response.filter;
    this.sorts = response.sorts;

    this.success = response.success;
    this.errors = response.errors;
    this.error = response.error;
    this.deleted = response.deleted;
  }
}
